import App from '../../../vendor_core/core/src/App';
import { Ease } from '../../../vendor_core/core/src/Ease';
import { Tween } from '../../../vendor_core/core/src/Tween';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import ReelVerticalSpinBehaviour from "../../../vendor_core/core/src/spinners/ReelVerticalSpinBehaviour";
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';

class MSReelVerticalSpinBehaviour extends ReelVerticalSpinBehaviour {
    protected setupSpeedupTweens() {
        if (!this.inSwipeSpin) {
            this.moveBackTween = Tween.to(
                this,
                App.config.moveBackDuration || 0.08,
                {
                    speed: -this.maxSpeed / (GameModel.turboSpin ? 10 : 5),
                    ease: Ease.Power2InOut,
                }
            );
        }
        this.speedUpTween = Tween.to(
            this,
            App.config.speedUpDuration || 0.3,
            {
                delay: this.inSwipeSpin
                    ? 0
                    : App.config.moveBackDuration || 0.08,
                speed: this.maxSpeed,
                ease: Ease.Power2In,
            }
        );
    }

    protected playStopSound(stopTime?: number): void {
        Tween.delayedCall(ReelGroup.instance.anticipationStarted ? 0.8 : 0, () => {
            const soundSettled =
            (stopTime || this.stopTime) - this.currStopTime <=
            (App.config.stopSoundOffset || 0.5);

        if (soundSettled && this.stopSoundPlayed === false) {
            this.stopSoundPlayed = true;
            // Best place to play black hole symbol landing anim
            this.reel.symbols.forEach(s => {
                if (s.id === 14) {
                    s.playAnimation("landing")
                }
            })

            const isNormalStop = !SpinModel.stopImmediately && !GameModel.turboSpin;
            const pan = isNormalStop ? this.computeReelStopPan() : 0;
            
            if(typeof this.stopSound === "string") {
                SoundController.playSound(
                    this.stopSound,
                    false,
                    null,
                    isNormalStop,
                    pan
                );
            } else {
                this.stopSound.forEach((sndName) => {
                    SoundController.playSound(
                        sndName,
                        false,
                        null,
                        isNormalStop,
                        pan
                    );
                });
            }
        }
        }, [], this);
    }

    private computeReelStopPan(range: number = 1.0) {
        const midReelIdx = Math.floor(ReelGroup.instance.reels.length / 2);
        const step = range / midReelIdx;
        const pan = (this.reel.reelIndex - midReelIdx) * step;
        return pan;
    }
}

export default MSReelVerticalSpinBehaviour;
